<template>
  <section>
    <el-table :data="tableData"
              v-loading="listLoading"
              @expand="expand"
              :row-key="getRowKeys"
              :expand-row-keys="expands">
      <el-table-column type="expand">
        <template scope="scope">
          <!--订单状态-->
          <el-collapse v-model="activeNames" accordion>
            <el-collapse-item title="订单状态" name="1">
              <div style="text-align: center;">
                <el-steps :space="100" :active="getOrderStatus(scope.row.order_status)" finish-status="success">
                  <el-step title="待支付"></el-step>
                  <el-step title="已支付"></el-step>
                  <el-step title="已发货"></el-step>
                  <el-step title="已收货"></el-step>
                  <el-step title="已完成"></el-step>
                  <el-step title="退货"></el-step>
                  <el-step title="已退款"></el-step>
                  <el-step title="失效"></el-step>
                </el-steps>
              </div>
            </el-collapse-item>

            <el-collapse-item title="商品列表" name="2">
              <div style="text-align: center;">
                <el-table :data="tableDataProduct"
                          border>
                  <el-table-column
                    label="名称"
                    prop="pro_name"
                    align="center"
                     min-width="500">
                  </el-table-column>
                  <el-table-column
                    label="价格"
                    prop="price"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="规格"
                    prop="spec_name"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="数量"
                    prop="pronum"
                    align="center">
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <el-collapse-item title="物流状态" name="3">
              <el-tabs v-model="wuliuAction" type="border-card" @tab-click="wuliuStatusClick">
                <el-tab-pane
                  v-for="(item, index) in wuliuStatusTabs"
                  :label="item"
                  :name="item"
                  :key="index"
                  style="text-align: center;">
         <!--          <el-steps :space="100" :active="wuliuStatus" finish-status="success">
                    <el-step title="揽货"></el-step>
                    <el-step title="跨镜运输"></el-step>
                    <el-step title="清关完成"></el-step>
                    <el-step title="国内派送"></el-step>
                    <el-step title="签收"></el-step>
                    <el-step title="结束"></el-step>
                  </el-steps> -->
                  <div v-if="wuliuInfos && wuliuInfos.length > 0" style="text-align: left;">物流信息：<p v-for="(item, index) in wuliuInfos" :key="index">{{item.context}}  {{item.time}}</p></div>
                </el-tab-pane>
              </el-tabs>
            </el-collapse-item>

            <el-collapse-item title="用户信息" name="4">
              <el-row>
                <el-col :offset="2" :span="2">微信编号：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userInfo.open_id}}</div>
                </el-col>
                <el-col :offset="2" :span="2">昵称：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userInfo.name}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">联系方式：</el-col>
                <el-col :span="8">
                  <div class="user-font" v-if="userInfo.tel">{{userInfo.tel}}</div>
                  <div class="user-font" v-else>暂无</div>
                </el-col>
                <el-col :offset="2" :span="2">天然豆：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userInfo.coins}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">邮箱：</el-col>
                <el-col :span="8">
                  <div class="user-font" v-if="userInfo.email">{{userInfo.email}}</div>
                  <div class="user-font" v-else>暂无</div>
                </el-col>
                <el-col :offset="2" :span="2">用户状态：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userStatus[userInfo.user_status]}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">用户等级：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userLevel[userInfo.level]}}</div>
                </el-col>
                <el-col :offset="2" :span="2">来源：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userChannel[userInfo.chennel]}}</div>
                </el-col>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="收货地址" name="5">
              <el-row>
                <el-col :offset="2" :span="2">收货人姓名：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.addr_name}}</div>
                </el-col>
                <el-col :offset="2" :span="2">联系方式：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.tel}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">省市县：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.sheng}}{{scope.row.shi}}{{scope.row.xian}}</div>
                </el-col>
                <el-col :offset="2" :span="2">详细地址：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.addr_detail}}</div>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </template>
      </el-table-column>
    <el-table-column
        label="订单编号"
        prop="order_num"
        align="center">
      </el-table-column>
      <el-table-column
        label="开始时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="收件人"
        prop="addr_name"
        align="center">
      </el-table-column>
        <el-table-column
        label="手机号"
        prop="tel"
        align="center">
      </el-table-column>
        <el-table-column
        label="省份"
        prop="sheng"
        align="center">
      </el-table-column>
      <el-table-column
        label="天然豆"
        prop="used_coin"
        align="center">
      </el-table-column>
         <el-table-column
        label="运费"
        prop="yunfei"
        align="center">
      </el-table-column>
      <el-table-column
        label="应付款"
        prop="ordersum"
        align="center">
      </el-table-column>
      <el-table-column
        label="实付款"
        prop="act_ordersum"
        align="center">
      </el-table-column>
      <el-table-column
        label="成本"
        prop="all_cost"
        align="center">
      </el-table-column>
       <el-table-column
        label="利润"
        prop="profit"
        align="center">
      </el-table-column>
     
      <el-table-column
        label="是否拆单"
        align="center">
        <template scope="scope">
          <div>{{deliverStatus[scope.row.part_deliver]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单状态"
        prop="order_status"
        align="center">
        <template scope="scope">
          <div>{{orderStatus[scope.row.order_status]}}</div>
        </template>
      </el-table-column>
             <el-table-column
        label="物流单位"
        prop="wuliu_company"
        align="center">
      </el-table-column>
          <el-table-column
        label="付款时间"
        prop="pay_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="店铺"
        prop="dianpu_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="流水号"
        prop="transaction_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="备注"
        prop="remark"
        align="center">
      </el-table-column>
     <el-table-column
        label="卖家备注"
        prop="seller_remark"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center"
        min-width="150">
        <template scope="scope">
               <el-button  type="primary" size="small" @click="openRemark(scope.row)">查看备注</el-button>
          <el-button v-if="scope.row.order_status == 601" :plain="true" type="info" size="small" @click="refund(scope.row, 0)">退款原因</el-button>
          <el-button v-else :plain="true" type="info" size="small" @click="refund(scope.row, 1)">退款</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--查看备注界面-->
    <el-dialog title="查看备注" v-model="seeRemarkVisible">
      <el-row>
        <el-col :offset="2" :span="4">买家备注：</el-col>
        <el-col :span="16">
          <div>{{remark}}</div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-col :offset="2" :span="4">卖家备注：</el-col>
        <el-col :span="16">
          <el-input type="textarea" rows="3" v-model="sellerRemark" placeholder="请输入备注"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="remarkSubmit" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>

    <!--添加物流界面-->
    <el-dialog title="添加物流" v-model="addWuliuVisible">
      <el-form :model="wuliuForm" label-width="150px" ref="wuliuForm">
        <el-form-item label="订单编号" prop="ordernum">
          <el-input v-model="wuliuForm.ordernum" :disabled="true" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="物流单位" prop="wuliucompany">
          <el-select v-model="wuliuForm.wuliucompany"  placeholder="请选择">
            <el-option
              v-for="(item, index) in wuliuCompany"
              :key="index"
              :label="item"
              :value="item"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流编号" prop="wuliunum">
          <el-input v-model="wuliuForm.wuliunum" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wuliuSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--修改价格界面-->
    <el-dialog title="修改价格" v-model="updatePriceVisible" size="tiny">
      <el-row>
        <el-col :offset="1" :span="6" style="line-height: 30px;">实际付款：</el-col>
        <el-col :span="17">
          <el-input v-model="actOrdersum" placeholder="请输入价格" size="small"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatePrice" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--修改地址界面-->
    <el-dialog title="修改收货地址" v-model="updateAddressVisible" size="small">
      <el-form :model="addressForm" label-width="150px" ref="addressForm">
        <el-form-item label="姓名" prop="addr_name">
          <el-input v-model="addressForm.addr_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="tel">
          <el-input v-model="addressForm.tel" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="sheng">
          <el-col :span="6">
           <el-input v-model="addressForm.sheng" auto-complete="off" size="small" required></el-input>
          </el-col>
          <el-col class="line" :span="2" :offset="1">-</el-col>
          <el-col :span="6">
           <el-input v-model="addressForm.shi" auto-complete="off" size="small" required></el-input>
          </el-col>
          <el-col class="line" :span="2" :offset="1">-</el-col>
          <el-col :span="6">
           <el-input v-model="addressForm.xian" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="详细地址" prop="addr_detail">
          <el-input v-model="addressForm.addr_detail" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card_num">
          <el-input v-model="addressForm.card_num" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="card_pic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeUpload1"
            :data='uploadForm'>
            <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeUpload2"
            :data='uploadForm'>
            <img v-if="imageUrl2" :src="imageUrl2" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateAddress" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--退款确认界面-->
    <el-dialog title="退款确认" v-model="refundVisible" size="tiny">
      <el-row>
        <el-col :offset="1" :span="6">退款金额：</el-col>
        <el-col :span="17">
          {{back_fee}}
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px;">
        <el-col :offset="1" :span="6">退款原因：</el-col>
        <el-col :span="17">
          {{reason}}
        </el-col>
      </el-row>
      <div v-if="isRefund == 1" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refundSubmit" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>

    <!--拆单规则界面-->
    <el-dialog title="拆单规则" v-model="chaidanVisbile" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <el-row>
        <el-col :span="24" class="goods-data">
          <el-checkbox-group v-model="selectGoodsData">
            <el-checkbox v-for="(item, i) of goodsData" :label="item" :key="item"></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="chaidanSubmit">拆单</el-button>
        <el-button type="primary" @click="cancelChaidanSubmit">提交</el-button>
      </div>
    </el-dialog>
    
    <!--批量物流-->
    <el-dialog title="批量物流" v-model="batchWuliuVisible">
      <el-row style="margin-top: 30px;">
        <el-col :offset="2" :span="4">批量物流：</el-col>
        <el-col :span="16">
          <el-input type="textarea" rows="25" v-model="batchWulius" placeholder="只支持【非拆单】物流，订单号|物流公司|运单号（每条按逗号隔开，快递公司必须按例子的名称）
            1524861378848092680|UEQ|3934980308849,
            1524861378848092680|中通速递|3934980308849,
            1524861378848092680|圆通速递|3934980308849,
            1524861378848092680|天天快递|3934980308849,
            1524861378848092680|韵达快递|3934980308849,"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchWuliuSubmit" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';
  import {formatDate} from '../../static/js/date.js';
  import basicdata from '../../static/config/basicdata.js'
  import {getQiniuToken} from '../../static/js/token.js'

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:10,
        listLoading: false,
        query: '',
        submitLoading: false,
        seeRemarkVisible: false,
        remark: '',
        sellerRemark: '',
        id: 0,
        addWuliuVisible: false,
        wuliuForm: {
          wuliucompany: '',
          ordernum: '',
          wuliunum: '',
          wuliuinfo: '',
          wuliustatus: 'canvassing',
          timestamp: 0,
          createtime: '',
          endtime: '',
          status: 0
        },
        partDeliver: '0',
        goodsData: [],
        selectGoodsData: [],
        showGoods: 'hidden',
        orderIds: '',
        wuliu_num: '',
        updatePriceVisible: false,
        actOrdersum: '',
        expands: [],
        getRowKeys(row) {
          return row.id;
        },
        activeNames: '1',
        getOrderStatus(status) {
          if(status === 1 || status === 2 || status === 3 || status === 4 || status === 6) {
            return status;
          } else if (status === 601) {
            return 7;
          } else if (status === 0) {
            return 8;
          } else {
            return 5;
          }
        },
        wuliuStatusTabs: [],
        wuliuStatus: 0,
        wuliuInfos: [],
        wuliuAction: '',
        userInfo: {},
        userStatus: basicdata.userStatus,
        userLevel: basicdata.userLevel,
        userChannel: basicdata.userChannel,
        deliverStatus: basicdata.deliverStatus,
        orderStatus: basicdata.orderStatus,
        wuliuCompany: basicdata.wuliuCompany,
        jiesuanStatus: basicdata.jiesuanStatus,
        updateAddressVisible: false,
        addressForm: {},
        showUploadList: false,
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        imageUrl1: '',
        imageUrl2: '',
        refundVisible: false,
        reason: '',
        back_fee: '',
        isRefund: 0,
        tableDataProduct: [],
        beginTime: '',
        endTime: '',
        orderStatusExcel: "200",
        chaidanVisbile: false,
        batchWuliuVisible: false,
        batchWulius:'',
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getOrderList(this.query);
      },
      getOrderList(query) {
        this.listLoading = true;
        let url = config.api_url + '/order/tuikuan';
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          } else {
            this.$message({
              message: '获取数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //打开备注窗口
      openRemark(row) {
        this.seeRemarkVisible = true;
        this.remark = row.remark ? row.remark : '无';
        this.sellerRemark = row.seller_remark;
        this.id = row.id;
      },
      //修改卖家备注
      remarkSubmit() {
        this.submitLoading = true;
        this.$axios.put(config.api_url + '/order/sellerRemark', {
          "id": this.id,
          "seller_remark": this.sellerRemark
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.submitLoading = false;
            this.seeRemarkVisible = false;
            this.search();
          } else {
            this.$message({
              message: '修改备注失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '修改备注异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //打开物流窗口
      openWuliu(row) {
        this.addWuliuVisible = true;
        this.id = row.id;
        this.wuliuForm.ordernum = row.order_num;
        this.orderIds = row.order_ids;
        this.wuliu_num = row.wuliu_num;
      },
      //打开批量物流
      batchWuliu(){
        this.batchWulius='';
        this.batchWuliuVisible = true;
      },
      //是否部分发货切换
      deliverChange(val) {
        if(val === '1') {
          this.showGoods = 'nohidden';
          this.getOrderProName();
        } else {
          this.showGoods = 'hidden';
        }
      },
      //提交物流
      wuliuSubmit() {
        this.$axios.post(config.api_url + '/wuliu',
          this.wuliuForm).then(response => {
          let data = response.data;
          if(data.state) {
            //this.putOrderNum();
            this.$refs['wuliuForm'].resetFields();
           } else {
            this.$message({
              message: '提交失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //修改订单编号
      putOrderNum() {
        let wuliunum = this.wuliu_num;
        wuliunum = this.wuliuForm.wuliunum;
        let partDeliver = 0
        this.$axios.put(config.api_url + '/order/wuliunum', {
          "id": this.id,
          "wuliu_num": wuliunum,
          "wuliu_company":this.wuliuForm.wuliucompany,
          "part_deliver": parseInt(partDeliver)
        }).then(response => {
          if(response.data.state) {
            this.putOrderFormDeliver();
          } else {
            this.$message({
              message: '提交失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //修改订单商品发货状态
      putOrderFormDeliver() {
        let idArr = [],
          ids = '';
        if(this.selectGoodsData.length > 0) {
          for(const item of this.selectGoodsData) {
            idArr.push(item.split('-')[1])
          }
          ids = idArr.toString();
        } else {
          ids = this.orderIds;
        }
        this.$axios.put(config.api_url + '/order/form/deliver/'+ids
        ).then(response => {
          if(response.data.state) {
            this.$message({
              message: '提交成功！',
              type: 'success'
            });
            this.addWuliuVisible = false;
            this.search();
          } else {
            this.$message({
              message: '提交失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //获取订单关联的商品
      getOrderProName() {
        this.$axios.get(config.api_url + '/order/form/proname/'+this.orderIds
        ).then(response => {
          let data = response.data;
          this.goodsData = [];
          if(data.state) {
            for(const item of data.msg) {
              for(var i=1;i<item.pronum+1;i++){
                console.log(i)
                this.goodsData.push(item.pro_name+'-'+item.id+'-'+i)
              }
            }
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取商品异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //修改价格窗口
      openPrice(row) {
        this.updatePriceVisible = true;
        this.actOrdersum = row.act_ordersum;
        this.id = row.id;
      },
      //修改价格
      updatePrice() {
        this.$axios.put(config.api_url + '/order/ordersum',{
          id: this.id,
          act_ordersum: parseFloat(this.actOrdersum)
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '价格修改成功',
              type: 'success'
            });
            this.updatePriceVisible = false;
            this.search();
          } else {
            this.$message({
              message: '价格修改失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '价格修改异常，请联系管理员',
            type: 'error'
          });
        })
      },
      openAddress(row) {
        this.updateAddressVisible = true;
        this.addressForm.id = row.id;
        this.addressForm.addr_name = row.addr_name;
        this.addressForm.tel = row.tel;
        this.addressForm.sheng = row.sheng;
        this.addressForm.shi = row.shi;
        this.addressForm.xian = row.xian;
        this.addressForm.addr_detail = row.addr_detail;
        this.addressForm.card_num = row.card_num;
        this.imageUrl1 = row.card_pic.split(',')[0];
        this.imageUrl2 = row.card_pic.split(',')[1];
      },
      updateAddress() {
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          this.submitLoading = true;
          let para = Object.assign({}, this.addressForm);
          para.card_pic = this.imageUrl1 + ',' + this.imageUrl2;
          this.$axios.put(config.api_url + '/order/address', 
          para).then(response => {
            if(response.data.state) {
               this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.$refs['addressForm'].resetFields();
              this.updateAddressVisible = false;
              this.search();
            } else {
              this.$message({
                message: '提交失败，请联系管理员',
                type: 'error'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '提交异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      //取消订单
      closeOrder(id) {
        this.$confirm('是否确认取消订单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/close/'+id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '订单取消成功!',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: '取消订单失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '取消订单异常，请联系管理员',
              type: 'error'
            });
          })
        });
      },
      //查询订单状态，物流状态等。
      expand(row, expanded) {
        if(expanded) {
          this.wuliuStatusTabs = row.wuliu_num ? row.wuliu_num.split(',') : [];
          this.wuliuAction = this.wuliuStatusTabs[0];
          this.getWuliuStatus(this.wuliuStatusTabs[0],row.order_num);
          this.getUserInfo(row.usid);
          this.expands = [];
          this.expands.push(row.id);
          this.getProduct(row.order_ids);
        }
      },
      wuliuStatusClick(tab, event) {
        this.getWuliuStatus(tab.name)
      },
      //查询物流状态
      getWuliuStatus(wuliuNum,orderNum) {
        if(wuliuNum) {
          this.$axios.get(config.api_url + '/wuliu/'+wuliuNum+'/'+orderNum
          ).then(response => {
            let data = response.data;
            if(data.state) {
              let result = data.msg;
              this.wuliuStatus = basicdata.wuliuStatus[result.wuliustatus];
              this.wuliuInfos = [];
              let obj = result.wuliuinfo ? JSON.parse(result.wuliuinfo) : '';
              if(obj&& obj.length > 0) {
                this.wuliuInfos = obj;
              }
            } else {
              this.$message({
                message: '查询物流状态失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '查询物流状态异常，请联系管理员',
              type: 'error'
            });
          });
        } else {
          this.wuliuInfos = [];
          this.wuliuStatus = 0;
        }
      },
      //获取用户信息
      getUserInfo(usid) {
        this.$axios.get(config.api_url + '/userinfo/'+usid
        ).then(response => {
          if(response.data.state) {
            this.userInfo = response.data.msg;
          } else {
            this.$message({
              message: '查询用户数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '查询用户数据异常，请联系管理员',
            type: 'error'
          });
        });
      },
      // 获取商品列表
      getProduct(orderIds) {
        this.$axios.get(config.api_url + '/order/form/'+orderIds
        ).then(response => {
          if(response.data.state) {
            this.tableDataProduct = response.data.msg;
          } else {
            this.$message({
              message: '获取商品列表失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '获取商品列表异常，请联系管理员',
            type: 'error'
          });
        });
      },
      makeImageName(file) {
        let fileName = 'card/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        fileName += '.' + mime;
        this.uploadForm.key = fileName;
        return fileName;
      },
      beforeUpload1(file) {
        this.imageUrl1 = basicdata.picUrl + this.makeImageName(file);
      },
      beforeUpload2(file) {
        this.imageUrl2 = basicdata.picUrl + this.makeImageName(file);
      },
      handleSuccess(response, file, fileList) {
        this.result = '上传成功'
      },
      handleError(error, response, file) {
        this.result = error.toString()
      },
      //重置物流
      resetWuliu(row) {
        this.$confirm('是否重置物流数据？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/resetwuliu/'+row.id
          ).then(response => {
            if(response.data.state) {
              this.$axios.put(config.api_url + '/order/form/resetwuliu/'+row.order_ids
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '重置物流数据成功!',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: '重置物流数据失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error)
                this.$message({
                  message: '重置物流数据异常，请联系管理员',
                  type: 'error'
                });
              });
            } else {
              this.$message({
                message: '重置物流数据失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '重置物流数据异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      //退款确认框
      refund(row, isRefund) {
        this.back_fee = row.back_fee;
        this.reason = row.reason;
        this.orderNum = row.order_num;
        this.refundVisible = true;
        this.isRefund = isRefund;
      },
      //退款提交
      refundSubmit() {
        this.$confirm('是否确认退款？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/status/'+this.orderNum+'/601'
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '退款失败，请联系管理员',
                type: 'warning'
              });
            }
            this.refundVisible = false;
            this.search();
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '退款异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      // 导出Excel
      export2Excel() {
        this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
        this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
        if(!this.beginTime || !this.endTime) {
          this.$message({
            message: '时间不能为空！',
            type: 'warning'
          });
          return;
        }
        this.$axios.get(config.api_url + '/order/excel/'+this.beginTime+'/'+this.endTime+'/'+this.orderStatusExcel
        ).then(response => {
          if(response.data.state) {
            if(response.data.msg) {
              console.log(response.data.msg);
              require.ensure([], () => {
                const { export_json_to_excel } = require('../../static/vendor/Export2Excel');
                const tHeader = ['订单编号', '订单日期', '发货人', '发货人联系电话', '订购人注册号', '订购人姓名', '订购人身份证号码', '订购人电话', '收货人姓名', '收件人身份证号码', '收货人电话', '省', '市', '区', '收货地址', '商品条形码', '商品序号', '商品名称', '商品外文名称','规格【临时】', '件数', '单价', '总价', '商品规格', '法定计量单位', '单位', '行邮税号', '行邮税名称', '行邮税率', 'HS编码', '原产地', '代扣税款', '非现金抵扣金额', '实际支付金额', '运费', '主要货物信息', '备注', '保价费', '商品组合条形码', '是否良品', '总税金', '是否投保价险', '是否投延误险', '投保价值', 'UEQ运单号', '扫描号', '净重', '毛重', '是否导入小票', '是否使用smartpost', '外文品牌', '商品简称', '是否提供身份证', '商品成分', '支付企业编号', '支付企业名称', '支付交易号', '支付时间', '电商商户名称', '电商商户备案号', '支付币种']; //对应表格输出的title
                const filterVal = ['order_num', 'create_time', '', '', 'name', 'addr_name', 'card_num', 'tel', 'addr_name', 'card_num', 'tel', 'sheng', 'shi', 'xian', 'addr_detail', 'upc', '', 'pro_name', '','spec_name', 'pronum', 'unit_price', 'price', '', '', '', '', '', '', '', 'origin_place', '', '', 'cash_fee', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']; // 对应表格输出的数据
                const list = response.data.msg;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, '订单列表_'+this.beginTime+'_'+this.endTime); //对应下载文件的名字
              });
            } else {
              this.$message({
                message: '无数据，请联系管理员！',
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '导出异常，请联系管理员！',
            type: 'error'
          });
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },
      // 拆单
      chaiDan(row) {
        this.$confirm('是否确定拆单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/part_deliver/'+row.id+'/1/3'
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '拆单失败，请联系管理员',
                type: 'warning'
              });
            }
            this.refundVisible = false;
            this.search();
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '拆单异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      // 拆单规则
      chaidanGuize(row) {
        this.chaidanVisbile = true;
        this.orderIds = row.order_ids;
        this.id = row.id;
        this.getOrderProName();
      },
      chaidanXiangxi(row) {
        this.$router.push("/order/chaidan/"+row.order_num);
      },
      // 取消拆单
      cancelChaidan(row) {
        this.$confirm('是否取消拆单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/part_deliver/'+row.id+'/-1/2'
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '取消拆单失败，请联系管理员',
                type: 'warning'
              });
            } else {
              this.$axios.delete(config.api_url + '/order/delete/wuliu/'+row.order_num
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '取消成功！',
                    type: 'success'
                  });
                  this.refundVisible = false;
                  this.search();
                }
              }).catch(error => {
                console.log(error)
                this.$message({
                  message: '取消拆单异常，请联系管理员',
                  type: 'error'
                });
              });
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '取消拆单异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      // 拆单
      chaidanSubmit() {
        let idArr = [],
          ids = '';
        if(this.selectGoodsData.length > 0) {
          for(const item of this.selectGoodsData) {
            idArr.push(item.split('-')[1])
          }
          ids = idArr.toString();
          this.$axios.post(config.api_url + '/order/chaidan/'+this.id+'/'+ids
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '拆单失败，请联系管理员',
                type: 'warning'
              });
            } else {
              this.$message({
                message: '拆单成功',
                type: 'success'
              });
              this.selectGoodsData = [];
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '拆单异常，请联系管理员',
              type: 'error'
            });
          });
        }
      },
      cancelChaidanSubmit() {
        this.$confirm('是否确认所有操作完成？', '提示', {}).then(() => {
          this.chaidanVisbile = false;
        });
      },
           //提交批量物流
      batchWuliuSubmit() {
            console.log(1111);
        console.log(this.batchWulius);
        this.$axios.put(config.api_url + '/order/batchwuliu/'+this.batchWulius
        ).then(response => {
          let data = response.data;
          if(data.state) {
            this.$message({
              message: '提交成功！',
              type: 'success'
            });
            this.batchWulius='';
            this.batchWuliuVisible = false;
            this.search();
          } else {
            this.$message({
              message: '提交批量物流失败，请联系管理员'+response.data.msg,
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交批量物流异常，请联系管理员',
            type: 'error'
          });
        })
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scope>
  .goods-data {
    cursor: default;
    background: #fff;
    border: 1px solid #d1dbe5;
    height: 100px;
    overflow-y: scroll;
  }
  .hidden {
    display: none;
  }
  .nohidden {
    display: block;
  }
  .el-checkbox {
    margin-left: 20px;
    margin-top: 7px;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// list1.vue?243fbf36